import { h } from 'preact';
export const Archive = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "21 8 21 21 3 21 3 8" }),
        h("rect", { x: "1", y: "3", width: "22", height: "5" }),
        h("line", { x1: "10", y1: "12", x2: "14", y2: "12" })));
};
//# sourceMappingURL=archive.js.map